import { HabitClass, HabitClassHabitEntriesItem } from "../../generated/model";

export interface ContributionData {
  date: string;
  count: number;
}

export type ViewPeriod = "week" | "year";

// Get date range based on view period
export const getDateRange = (period: ViewPeriod) => {
  const endDate = new Date();
  const startDate = new Date();

  switch (period) {
    case "week":
      startDate.setDate(endDate.getDate() - 6); // 7 days total
      break;
    case "year":
      startDate.setDate(endDate.getDate() - 364); // 365 days total
      break;
  }

  return { startDate, endDate };
};

// Format habit entries for the contribution heatmap
export const formatContributionData = (
  habit: HabitClass,
  habitEntries: HabitClassHabitEntriesItem[],
  viewPeriod: ViewPeriod = "year"
): ContributionData[] => {
  const relevantEntries = habitEntries.filter(
    (entry) => entry.habitId === habit.id
  );

  const entriesMap = new Map<string, number>();
  relevantEntries.forEach((entry) => {
    const dateKey = entry.date;
    // @ts-ignore
    // Ensure dateKey is in YYYY-MM-DD format
    entriesMap.set(dateKey, (entriesMap.get(dateKey) || 0) + 1);
  });

  const { startDate, endDate } = getDateRange(viewPeriod);
  const contributionData: ContributionData[] = [];

  // Generate data for the specified date range
  for (let d = new Date(startDate); d <= endDate; d.setDate(d.getDate() + 1)) {
    const dateString = d.toISOString().split("T")[0];
    const count = entriesMap.get(dateString) || 0;

    contributionData.push({
      date: dateString,
      count,
    });
  }

  return contributionData;
};
